import { useState } from 'react';
import { MAXIMUM_FILE_SIZE, MAXIMUM_FILES } from '../consts';
export const useFileUpload = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [images, setImages] = useState([]);
  const [files, setFiles] = useState([]);
  const uploadFile = file => {
    return new Promise(resolve => {
      const fileUrl = URL.createObjectURL(file);
      resolve(fileUrl);
    });
  };
  const handleFileSelected = async (files, errorsMessages) => {
    const {
      uploadErrorText,
      maxSizeErrorText,
      maxFilesErrorText,
      fileTypeErrorText
    } = errorsMessages;
    if (!files || isLoading) {
      return;
    }
    clearErrors();
    setIsLoading(true);
    const newImages = [];
    let filesArray = Array.from(files);
    try {
      const supportedFormats = ['png', 'jpeg', 'jpg'];
      filesArray = filesArray.filter(file => {
        var _file$name$split$pop;
        const extension = ((_file$name$split$pop = file.name.split('.').pop()) == null ? void 0 : _file$name$split$pop.toLowerCase()) ?? '';
        const isSupported = supportedFormats.includes(extension);
        if (!isSupported) {
          setError(fileTypeErrorText);
          return false;
        }
        return true;
      });
      if (filesArray.length + images.length > MAXIMUM_FILES) {
        setError(maxFilesErrorText);
        filesArray = filesArray.slice(0, MAXIMUM_FILES - images.length);
      }
      for (const file of filesArray) {
        if (file.size > MAXIMUM_FILE_SIZE) {
          setError(maxSizeErrorText);
          continue;
        }
        const uploadedFileUrl = await uploadFile(file);
        newImages.push(uploadedFileUrl);
      }
      setImages(prevImages => [...prevImages, ...newImages]);
      setFiles(filesArray.filter(fileToFilter => fileToFilter.size < MAXIMUM_FILE_SIZE));
    } catch (err) {
      setError(uploadErrorText);
      console.error(err);
    }
    setIsLoading(false);
  };
  const handleRemoveImage = index => {
    clearErrors();
    setImages(prevImages => prevImages.filter((_, i) => i !== index));
  };
  const clearErrors = () => {
    setError(null);
  };
  return {
    isLoading,
    error,
    handleFileSelected,
    handleRemoveImage,
    images,
    files,
    clearErrors
  };
};
//# sourceMappingURL=useFileUpload.js.map